// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_bambu_screws/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_bambu_screws: ModuleSchema = {
  "id": "core_bambu_screws",
  "uniqueId": "B3D_C6AQJ",
  "createdAt": "2026-10-02T05:13:34.729Z",
  "updatedAt": "2026-10-28T14:58:31.097Z",
  "label": "Base Screws",
  "description": "Template starting structure for creating new 3D parametric modules",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_SCREW"
  ],
  "sliders": [
    {
      "key": "screwCount",
      "label": "Display Count (1=Single Screw, 4=Full Set of 4)",
      "min": 1,
      "max": 4,
      "default": 4,
      "step": 3,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "screwHoleDia",
      "label": "Thread Outer Diameter (M8)",
      "min": 5,
      "max": 12,
      "default": 8,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "screwShankH",
      "label": "Threaded Shank Height",
      "min": 4,
      "max": 16,
      "default": 7,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "screwHeadDia",
      "label": "Foot Head Diameter",
      "min": 6,
      "max": 18,
      "default": 10,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "screwHeadH",
      "label": "Foot Head Height",
      "min": 2,
      "max": 8,
      "default": 3,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "screwPcd",
      "label": "PCD Circle (for 4 Screws)",
      "min": 50,
      "max": 100,
      "default": 75,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "screw_feet",
      "label": "4x Male Feet Screws",
      "default": "#9CA3AF",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "screws_obj",
      "label": "Bambu Base Feet Screws M8",
      "name": "Bambu Base Feet Screws M8",
      "color": "#9CA3AF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "screw_feet",
          "label": "4x Male Feet Screws",
          "name": "4x Male Feet Screws",
          "groupId": 0,
          "colorKey": "screw_feet",
          "defaultColor": "#9CA3AF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Base Screws",
      "groupId": -1
    }
  ]
};
